export function Logo() {
  return (
    <img
      src="/assets/amp-mineops-logo.png"
      alt="AMP MineOps"
      className="h-9 w-auto"
      style={{ filter: "brightness(0) saturate(100%) invert(82%) sepia(30%) saturate(500%) hue-rotate(100deg) brightness(101%) contrast(92%)" }}
    />
  );
}

export function LogoFull() {
  return (
    <div className="flex flex-col items-center">
      <img
        src="/assets/amp-mineops-logo.png"
        alt="AMP MineOps"
        className="h-16 w-auto mb-3"
        style={{ filter: "brightness(0) saturate(100%) invert(82%) sepia(30%) saturate(500%) hue-rotate(100deg) brightness(101%) contrast(92%)" }}
      />
      <p className="text-muted-foreground text-sm">Contractor Reporting System</p>
    </div>
  );
}
